import { createBrowserRouter } from "react-router-dom";
import Home from "./Routes/Home";
import About from "./Routes/About";
import Layout from "./Routes/Components/Layout"; // Import the Layout component
import Music from "./Routes/Music";
import Contact from "./Routes/Contact";
import NotFound from "./Routes/NotFound";

export const router = createBrowserRouter([
  {
    path: "/",
    element: <Layout />,
    children: [
      {
        path: "/",
        element: <Home />,
      },
      {
        path: "about",
        element: <About />,
      },
      {
        path: "music",
        element: <Music />,
      },
      {
        path: "contact",
        element: <Contact />,
      },
      {
        path: "*",
        element: <NotFound />,
      },
    ],
  },
]);
